<h2 class="title">
    <ng-content></ng-content>
</h2>
<ul class="list">
    @for (crossSellingProduct of crossSellingProducts; track trackBySku(i, crossSellingProduct); let i = $index) {
    <li class="item">
        <h-product-page-grid-item
            [crossSellingProduct]="crossSellingProduct"
            [list]="gridTitle"
            [index]="i"
            (imageInViewPort)="sendLazyLoadImpressionEvent($event)">
        </h-product-page-grid-item>
    </li>
    }
</ul>
